import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import { FormInput, FormField } from "buoy-core"
import { SVG_URL } from "../constants"

const Container = styled.div`
  position: relative;
  box-sizing: border-box;
  max-width: ${props => props.maxWidth ? props.maxWidth : "400px"};
`

const Field = styled(FormField)`
  h2 {
    margin-top: 0;
  }
  p {
    bottom: unset;
    top: 66px;
  }
`

const TextArea = FormInput.withComponent("textarea")

const Icon = styled.img`
  width: 0.917rem;
  height: 0.617rem;
  position: absolute;
  right: 0.75rem;
  top: 2.2rem;
`

class InputWrapper extends React.Component {
  constructor(props) {
    super(props)
    this.state = { success: false, error: false }
  }

  validate = (text, blurring) => {
    let valid = true
    if (this.props.validate) valid = this.props.validate(text)
    let newState = {}
    if (valid) {
      newState.error = false
      if (this.props.showValid) newState.success = true
    } else {
      newState.success = false
      if (blurring) newState.error = true
    }
    this.setState(newState)
  }

  onBlur = () => {
    this.validate(this.props.value, true)
  }

  onKeyDown = e => {
    let val = e.keyCode || e.which
    if (val === 13) {
      // Enter
      this.onBlur()
    }
  }

  handleChange = e => {
    e.stopPropagation()
    let { value } = e.target
    this.validate(value)
    this.props.onChange(value)
  }

  render() {
    let { className, value, type, center, ...props } = this.props
    const Component = props.large ? TextArea : Field
    return (
      <Container className={className} {...props}>
        <Component
          {...this.state}
          {...props}
          error={this.props.error || this.state.error}
          onChange={this.handleChange}
          onBlur={this.onBlur}
          valid={!this.state.error || this.state.success}
          onKeyDown={this.onKeyDown}
          value={value}
          center={center}
          placeholder={props.placeholder || props.label}
          type={type}
          ariaLabel={props.ariaLabel || props.label}
          showError={(this.state.error ||
            (this.props.error && this.props.showPassedError)) &&
            this.props.errorMsg}
          errorMessage={this.props.errorMsg}
        />
        {this.state.success && <Icon src={`${SVG_URL}green-check.svg`} />}
      </Container>
    )
  }
}

InputWrapper.propTypes = {
  validate: PropTypes.func,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  showValid: PropTypes.bool,
  errorMsg: PropTypes.string,
}

export { FormInput as Input, Icon, TextArea, InputWrapper as default }



// WEBPACK FOOTER //
// ./assets/common/components/Input.js